const routes = [
    // {
    //     path: "/test",
    //     name: "test",
    //     component:() => import(/* webpackChunkName: "test" */ '../views/test/test.vue')
    // },
    // {path: "/", redirect: "/test"},
    {path: "/", redirect: "mainPage"},
    {
        path: "/",
        name: "layout",
        component: () => import(/* webpackChunkName: "Home" */ '@/components/layout/index.vue'),
        children:[
            {
                path: "/mainPage",
                name: "mainPage",
                component:() => import(/* webpackChunkName: "mainPage" */ '../views/mainPage/mainPage.vue')
            },
            {
                path: "/aboutUs",
                name: "aboutUs",
                redirect: "/aboutUs/enterpriseIntroduction",
                component:() => import(/* webpackChunkName: "aboutUs" */ '../views/aboutUs/aboutUsLayout.vue'),
                children:[
                    {
                        path: "/aboutUs/enterpriseIntroduction",
                        name: "enterpriseIntroduction",
                        component:() => import(/* webpackChunkName: "enterpriseIntroduction" */ '../views/aboutUs/enterpriseIntroduction.vue')
                    },
                    {
                        path: "/aboutUs/enterpriseCulture",
                        name: "enterpriseCulture",
                        component:() => import(/* webpackChunkName: "enterpriseCulture" */ '../views/aboutUs/enterpriseCulture.vue')
                    },
                    {
                        path: "/aboutUs/developmentHistory",
                        name: "developmentHistory",
                        component:() => import(/* webpackChunkName: "developmentHistory" */ '../views/aboutUs/developmentHistory.vue')
                    },
                    {
                        path: "/aboutUs/honor",
                        name: "honor",
                        component:() => import(/* webpackChunkName: "honor" */ '../views/aboutUs/honor.vue')
                    },
                    {
                        path: "/aboutUs/laboratory",
                        name: "laboratory",
                        component:() => import(/* webpackChunkName: "laboratory" */ '../views/aboutUs/laboratory.vue')
                    },
                    {
                        path: "/aboutUs/contactUs",
                        name: "contactUs",
                        component:() => import(/* webpackChunkName: "contactUs" */ '../views/aboutUs/contactUs.vue')
                    },
                ]
            },
            {
                path: "/ourService",
                name: "ourService",
                redirect: "/ourService/ourServiceMainPage",
                component:() => import(/* webpackChunkName: "ourService" */ '../views/ourService/ourServiceLayout.vue'),
                children:[
                    {
                        path: "/ourService/ourServiceMainPage",
                        name: "ourServiceMainPage",
                        component:() => import(/* webpackChunkName: "ourServiceMainPage" */ '../views/ourService/ourServiceMainPage.vue')
                    },
                    {
                        path: "/ourService/ourServicePesticide",
                        name: "ourServicePesticide",
                        component:() => import(/* webpackChunkName: "ourServicePesticide" */ '../views/ourService/ourServicePesticide.vue')
                    },
                    {
                        path: "/ourService/chemicalRegister",
                        name: "chemicalRegister",
                        component:() => import(/* webpackChunkName: "chemicalRegister" */ '../views/ourService/chemicalRegister.vue')
                    },
                    {
                        path: "/ourService/makeUp",
                        name: "makeUp",
                        component:() => import(/* webpackChunkName: "makeUp" */ '../views/ourService/makeUp.vue')
                    },
                    {
                        path: "/ourService/otherService",
                        name: "otherService",
                        component:() => import(/* webpackChunkName: "otherService" */ '../views/ourService/otherService.vue')
                    },
                ]
            },
            {
                path: "/joinUs",
                name: "joinUs",
                component:() => import(/* webpackChunkName: "joinUs" */ '../views/joinUs/joinUs.vue')
            },
        ]
    }
]

export default routes
